import { ADD_AGGREGATION_COUNTS, AggregationCountsAction, SET_AGGREGATION_COUNTS_LOADING } from '@Actions/aggregationCountsActions';

import { IAggregationCounts } from '@ClientServices/api/aggregationCountsApi';

interface IAggregationCountsState {
  aggregationCounts: { [key: string]: IAggregationCounts };
  aggregationCountsLoading: { [key: string]: boolean };
}

export const defaultState: IAggregationCountsState = {
  aggregationCounts: {},
  aggregationCountsLoading: {}
};

export default function (state = defaultState, action: AggregationCountsAction) {
  switch (action.type) {
    case ADD_AGGREGATION_COUNTS:
      return {
        ...state,
        aggregationCounts: {
          ...state.aggregationCounts,
          [action.payload.match]: action.payload.aggregationCounts
        }
      };
    case SET_AGGREGATION_COUNTS_LOADING:
      return {
        ...state,
        aggregationCountsLoading: {
          ...state.aggregationCountsLoading,
          [action.payload.match]: action.payload.loading
        }
      };
    default:
      return state;
  }
}
